import { type LucideIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/style';

interface InfoCardProps {
  title: string;
  icon?: LucideIcon;
  header?: React.ReactNode;
  color?: 'orange' | 'red' | 'green' | 'blue' | 'gray';
}

export function InfoCard(props: PropsWithChildren<InfoCardProps>) {
  const { title, icon: Icon, header, color, children } = props;

  return (
    <div
      className={cn('flex flex-row gap-4 p-4 rounded-xl border text-gray-700', {
        'bg-gray-50 border-gray-300': !color,
        'bg-orange-50 border-orange-200': color === 'orange',
        'bg-red-50 border-red-200': color === 'red',
        'bg-green-50 border-green-200': color === 'green',
        'bg-blue-50 border-blue-300': color === 'blue',
        'bg-gray-50 border-gray-300 ': color === 'gray',
      })}
    >
      {Icon && (
        <Icon
          className={cn('size-6 shrink-0', {
            'text-primary': !color,
            'stroke-orange-600': color === 'orange',
            'stroke-red-600': color === 'red',
            'stroke-green-700': color === 'green',
            'stroke-blue-600': color === 'blue',
            'stroke-gray-600': color === 'gray',
          })}
        />
      )}
      <div className="flex flex-col gap-2 w-full">
        <div className="flex items-center gap-2">
          <span className="text-gray-900 text-sm font-semibold">{title}</span>
          {header}
        </div>
        {children}
      </div>
    </div>
  );
}
